// Fun gerunds shown in place of "Thinking…" while the agent works — half make
// sense, half absolutely don't. Add/remove freely; keep them unique gerunds.
export const THINKING_WORDS = [
  "Pondering",
  "Noodling",
  "Percolating",
  "Shimmying",
  "Frolicking",
  "Marinating",
  "Ruminating",
  "Conjuring",
  "Cogitating",
  "Tinkering",
  "Vibing",
  "Scheming",
  "Brewing",
  "Wrangling",
  "Finagling",
  "Cavorting",
  "Bamboozling",
  "Concocting",
  "Spelunking",
  "Hatching",
  "Simmering",
  "Doodling",
  "Manifesting",
  "Synthesizing",
  "Untangling",
  "Calibrating",
  "Channeling",
  "Divining",
  "Excavating",
  "Fermenting",
  "Incubating",
  "Juggling",
  "Levitating",
  "Meandering",
  "Optimizing",
  "Plotting",
  "Rummaging",
  "Sculpting",
  "Transmuting",
  "Unfurling",
  "Zhuzhing",
  "Crystallizing",
  "Distilling",
  "Effervescing",
  "Foraging",
  "Harmonizing",
  "Galloping",
  "Mulling",
  "Whirring",
  "Bedazzling",
];

export function randomThinkingWord() {
  return THINKING_WORDS[Math.floor(Math.random() * THINKING_WORDS.length)];
}
